import { simpleSet } from '@r/reducers/utils';

const setCalculationModeDrawerSystemsValue = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.drawerSystems.value;

export const value = setCalculationModeDrawerSystemsValue(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_DRAWER_SYSTEMS_VALUE',
  { value: '', label: '' }
);
